import { useToast } from "@agney/ir-toast";
import {
  IonButton,
  IonHeader,
  IonInput,
  IonItem,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, {  useState } from "react";
import { ApiResponse } from "../../../../models";
import { utilService } from "../../../../services/utilService";
import { NewSupportStaffInputParams } from "../../StatusBoard.model";
import { statusBoardService } from "../../StatusBoard.service";
import "./NewSupportStaff.scss";
import { useTranslation } from "react-i18next";

interface ContainerProps {
  onCancel: () => void;
}

const NewSupportStaff: React.FC<ContainerProps> = (props) => {
  const [showAlert, setShowAlert] = useState(true);
  const [textValue, setTextValue] = useState<string>("");
  const { t } = useTranslation("statusBoard"); 
  const Toast = useToast();

  const closeModal = () => {
    setShowAlert(false);
    props.onCancel();
  };

  const onChangeValue = (event: any) => {
    if (trimField(event.detail.value) === "") {
      setTextValue("");
    } else {
      setTextValue(event.detail.value);
    }
  };

  const trimField = (trimField: any) => {
    const value = trimField ? trimField.trim() : "";
    return value;
  };
  const addSupportStaff = async () => {
    const params: NewSupportStaffInputParams = {
      name: textValue,
      site_id: statusBoardService.statusBoardData
        ? statusBoardService.statusBoardData[0].site?.siteId
        : null,
      reg_code: utilService.getNetwork(),
    };
    const respResult: ApiResponse = await statusBoardService.addNewSupportStaff(
      params
    );
    if (respResult.isSuccess) {
      props.onCancel();
      Toast.success(t("staffAddedSuccess"));
    } else {
      if(textValue?.length>30){
Toast.error(t("maxCharError"));
      }else{
        Toast.error(respResult.message);
      }
    }
  };

  return (
    <IonModal
      isOpen={showAlert}
      backdropDismiss={false}
      className="new-support-staff-modal"
    >
      <div className="new-support-staff-cont">
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle className="title">
              {" "}
                {t("newSupportStaff")}
              <span
                className="close-popup icon-close"
                onClick={closeModal}
              ></span>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="content-cont">
          <IonItem>
            <IonInput
              maxlength={60}
              value={textValue}
              className="input-name"
             placeholder={t("supportStaffName")}
              onIonChange={(event) => onChangeValue(event)}
            ></IonInput>
          </IonItem>
          <IonButton
            className="btn update-col-btn"
            disabled={textValue === "" ? true : false}
            onClick={addSupportStaff}
          >
           <span>{t("new")}</span>
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default NewSupportStaff;
